import { FETCH_DETAILS_START, FETCH_DETAILS_SUCCESS, FETCH_DETAILS_FAIL } from '../actions/actionTypes';

const initialState = {
    user: {
        data: null,
        loading: false,
        error: null
    },
    cart: {
        data: null,
        loading: false,
        error: null
    },
    cartPricing: {
        data: null,
        loading: false,
        error: null
    },
    addVoucher: {
        data: null,
        loading: false,
        error: null
    },
    checkout: {
        data: null,
        loading: false,
        error: null
    },
    item: {
        data: null,
        loading: false,
        error: null
    },
    currentLocation: {
        data: null,
        loading: false,
        error: null
    },
    contact: {
        data: null,
        loading: false,
        error: null
    },
    price: {
        data: null,
        loading: false,
        error: null
    },
    searchLocation: {
        data: null,
        loading: false,
        error: null
    },
    reservation: {
        data: null,
        loading: false,
        error: null
    },
    cancelReservation: {
        data: null,
        loading: false,
        error: null
    },
    order: {
        data: null,
        loading: false,
        error: null
    },
    paymentAccount: {
        data: null,
        loading: false,
        error: null
    },
    addDirectDebit: {
        data: null,
        loading: false,
        error: null
    },
    updateDirectDebit: {
        data: null,
        loading: false,
        error: null
    },
    community: {
        data: null,
        loading: false,
        error: null
    },
    communityContact: {
        data: null,
        loading: false,
        error: null
    },
    communityCompany: {
        data: null,
        loading: false,
        error: null
    },
    invoice: {
        data: null,
        loading: false,
        error: null
    }
};

/* * * * * * * * * * * * * * * * * * * * * * * * *
* METHODS THAT UPDATE STATES WITH CORRECT VALUES *
* * * * * * * * * * * * * * * * * * * * * * * *  */
const fetchDetailsStart = (state, action) => {
    const updatedInnerStates = {...state[action.identifier], ...{
        loading: true
    }};

    return {...state, ...{
        [action.identifier]: updatedInnerStates
    }};
};

const fetchDetailsSuccess = (state, action) => {
    const updatedInnerStates = {...state[action.identifier], ...{
        data: action.data,
        loading: false,
        error: null
    }};

    return {...state, ...{
        [action.identifier]: updatedInnerStates
    }};
};

const fetchDetailsFail = (state, action) => {
    const updatedInnerStates = {...state[action.identifier], ...{
        data: null,
        loading: false,
        error: action.error
    }};

    return {...state, ...{
        [action.identifier]: updatedInnerStates
    }};
};

/* * * * * * * * *
* REDUCER METHOD *
* * * * * * * *  */
// Depending on the active action type, execute the correct function to update the correct states with the correct values
// Pass two parameters, first is the old state values, second is the new state values, these are passed from actions
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DETAILS_START: return fetchDetailsStart(state, action);
        case FETCH_DETAILS_SUCCESS: return fetchDetailsSuccess(state, action);
        case FETCH_DETAILS_FAIL: return fetchDetailsFail(state, action);
        default: return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/details.js